export default __webpack_public_path__ + "static/partner-form-banner2-442c15c0fa871fdf24e9833adf521b86.jpg";